function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.4 19.589c-.4-.4-.4-.9-.1-1.3 1.8-2.3 2.8-5.2 2.8-8.3 0-3.1-1.1-6-2.8-8.3-.3-.4-.3-.9.1-1.3s1.1-.4 1.4.1c2 2.6 3.2 5.9 3.2 9.5 0 3.6-1.2 6.8-3.2 9.5-.4.4-1 .5-1.4.1zm-3.3-3.7c-.3-.3-.4-.8-.1-1.2.9-1.3 1.4-2.9 1.4-4.7 0-1.7-.5-3.3-1.4-4.7-.2-.4-.2-.9.1-1.2.4-.4 1.1-.3 1.5.2 1.1 1.6 1.7 3.6 1.7 5.7s-.6 4.1-1.7 5.7c-.3.5-1.1.6-1.5.2zm-3.2 1.2c-.7.6-1.4.5-1.9.2l-4.6-3.3c-.2-.1-.4-.2-.6-.2H.9c-.5 0-.9-.4-.9-.9v-5.3c0-.7.6-1.4 1.4-1.4h4.3c.3 0 .5 0 .6-.2l4.5-3.7c.5-.4 1.2-.5 2 .1.2.1.3.5.3.7v13.2c.1.4 0 .6-.2.8z",
  fill: "#231F20",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20"
  }, props), _ref);
};

export default SvgComponent;